// src/api/queries/change-requests.js
/**
 * Хуки заявок на изменение. GET /change-requests, POST / (создание),
 * POST /:id/decide { approved, reason }.
 *
 * useCreateChangeRequestMutation.onSuccess инвалидирует только
 * ["change-requests"] и ["notifications"]: создание заявки не меняет
 * tasks/projects (только change_requests + уведомления получателям).
 * Раньше инвалидировались ["tasks"]/["projects"] — лишний refetch.
 *
 * useDecideChangeRequestMutation.onSuccess инвалидирует:
 *   - ["change-requests"] — список;
 *   - ["tasks"], ["task"] — решение меняет поля задачи;
 *   - ["projects"], ["project"] — и/или проекта;
 *   - ["notifications"] — уведомления о решении.
 */
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../client";

export const CHANGE_REQUESTS_KEY = ["change-requests"];

export function useChangeRequestsQuery(options = {}) {
  return useQuery({
    queryKey: CHANGE_REQUESTS_KEY,
    queryFn: () => api.get("/change-requests"),
    staleTime: 30 * 1000,
    ...options,
  });
}

export function useCreateChangeRequestMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => api.post("/change-requests", body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: CHANGE_REQUESTS_KEY });
      qc.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
}

export function useDecideChangeRequestMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, approved, reason }) =>
      api.post(`/change-requests/${id}/decide`, { approved, reason }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: CHANGE_REQUESTS_KEY });
      qc.invalidateQueries({ queryKey: ["tasks"] });
      qc.invalidateQueries({ queryKey: ["projects"] });
      qc.invalidateQueries({ queryKey: ["task"] });
      qc.invalidateQueries({ queryKey: ["project"] });
      qc.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
}
